// extracted by mini-css-extract-plugin
export default {"FooterOverall":"Footer_FooterOverall__uHPSU","FooterCopyright":"Footer_FooterCopyright__++E76"};